<template>
<transition name="modelMask">
    <div class="modal-mask" v-show="showModal">
        <div class="modal-wrapper">
            <div class="modal-container">
                <div class="modal_header">
                    <slot name="header">
                        <span class="fs18">{{title}}</span>
                    </slot>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true" @click="handleClose">×</span>
                    </button>
                </div>
                <div class="modal_body">
                    <slot name="body">
                        暂无内容
                    </slot>
                </div>

                <div class="modal_footer">
                    <slot name="footer">
                        <button class="btn btn-secondary" @click="handleClose">取消</button>
                        <!-- <button type="button" class="btn btn-primary">确定</button> -->
                    </slot>
                </div>
            </div>
        </div>
    </div>
</transition>
</template>

<script>
export default {
    name: 'modelMask',
    props: {
        showModal: {
            type: Boolean,
            required: true,
        },
        title: {
            type: String,
            default: '提示'
        }
    },
    data() {
        return {}
    },
    mounted() {},
    methods: {
        handleClose() {
            this.$emit("update:showModal", false);
        },
    }
}
</script>

<style scoped>
.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
}

.modal-wrapper {
    display: table-cell;
    vertical-align: middle;
}

.modal-container {
    width: 520px;
    margin: 0px auto;
    /* padding: 20px 30px; */
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;
}

.modal_header {
    display: flex;
    -ms-flex-align: start;
    align-items: center;
    -ms-flex-pack: justify;
    justify-content: space-between;
    /* padding: 1rem 1rem; */
    padding: 15px 20px;
    /* border-bottom: 1px solid #dee2e6; */
    border-bottom: 1px solid #fff;
    border-top-left-radius: calc(0.3rem - 1px);
    border-top-right-radius: calc(0.3rem - 1px);
}

.modal_header .close {
    /* padding: 1rem 1rem;
    margin: -1rem -1rem -1rem auto; */
    padding: 20px 20px;
    margin: -20px -20px -20px auto;
}

button.close {
    padding: 0;
    background-color: transparent;
    border: 0;

}

.close {
    float: right;
    /* font-size: 1.5rem; */
    font-size: 28px;
    font-weight: 700;
    line-height: 1;
    color: #000;
    text-shadow: 0 1px 0 #fff;
    opacity: .5;
}

.modal_body {
    padding: 15px 20px;
    box-sizing: border-box;
    max-height: 500px;
    overflow-y: scroll;

}

::-webkit-scrollbar {
    display: none;
}

.modal_footer {
    padding: 15px;
    text-align: right;
    /* border-top: 1px solid #e5e5e5; */
    border: none;
}

.modal-default-button {
    float: right;
}

/*
 * the following styles are auto-applied to elements with
 * v-transition="modal" when their visiblity is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modelMask-enter,
.modelMask-leave {
    opacity: 0;
}

.modelMask-enter .modal-container,
.modelMask-leave .modal-container {
    transform: scale(1.1);
}

.btn {
    display: inline-block;
    font-weight: 400;
    color: #212529;
    text-align: center;
    vertical-align: middle;
    user-select: none;
    background-color: transparent;
    border: none;
    font-size: 1rem;
    line-height: 1.5;
    border-radius: 0.25rem;
    outline: none;
}

.btn-primary {
    color: #fff;
    background-color: #007bff;
    border-color: #007bff;
}

.btn-secondary {
    color: #fff;
    background-color: #6c757d;
    border-color: #6c757d;
}

.modal_footer .btn+.btn {
    margin-bottom: 0;
    margin-left: 10px;
}

.fs18 {
    font-size: 18px;
}

/* //  移动端 */
@media screen and (min-width: 300px) and (max-width: 768px) {

    .modal-container {
        width: 90vw;
        margin: 0 auto;
        /* padding: 20px 30px; */
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
        font-family: Helvetica, Arial, sans-serif;
    }

    .modal_header {
        display: flex;
        -ms-flex-align: start;
        align-items: center;
        -ms-flex-pack: justify;
        justify-content: space-between;
        /* padding: 1rem 1rem; */
        padding: 2rem 2.6667rem;
        /* border-bottom: 1px solid #dee2e6; */
        border-bottom: 1px solid #fff;
        border-top-left-radius: calc(0.3rem - 1px);
        border-top-right-radius: calc(0.3rem - 1px);
    }

    .modal_header .close {
        padding: 2.6667rem 2.6667rem;
        margin: -2.6667rem -2.6667rem -2.6667rem auto;
    }

    button.close {
        padding: 0;
        background-color: transparent;
        border: 0;

    }

    .close {
        float: right;
        /* font-size: 1.5rem; */
        font-size: 7.4667rem;
        font-weight: 700;
        line-height: 1;
        color: #000;
        text-shadow: 0 1px 0 #fff;
        opacity: .5;
    }

    .modal_body {
        padding: 2rem 2.6667rem;
        box-sizing: border-box;
        max-height: 60vh;
        overflow-y: scroll;

    }

    ::-webkit-scrollbar {
        display: none;
    }

    .modal_footer {
        padding: 4rem;
        text-align: right;
        /* border-top: 1px solid #e5e5e5; */
        border: none;
    }

    .modal-default-button {
        float: right;
    }

    .fs18 {
        font-size: 4.8rem;
    }
  .modal_footer {
      padding: 4rem;
  }
.btn {
    display: inline-block;
    font-weight: 400;
    color: #212529;
    text-align: center;
    vertical-align: middle;
    user-select: none;
    background-color: transparent;
    border: none;
    font-size: 4.2667rem;
    line-height: 1.5;
    border-radius: 4px;
    outline: none;
}

.btn-primary {
    color: #fff;
    background-color: #007bff;
    border-color: #007bff;
}

.btn-secondary {
    color: #fff;
    background-color: #6c757d;
    border-color: #6c757d;
}

.modal_footer .btn+.btn {
    margin-bottom: 0;
    margin-left: 2.6667rem;
}

}
</style>
<style>
.btn-primary:active:focus {
    outline: 0;
}

.btn:active:focus,
.btn:focus {
    outline: 0;
}
</style>
